export const BUSINESS = {
  name: "Releaf Wellness & Aesthetics",
  provider: "Nichole Olsen",
  title: "Nurse Practitioner",
  phone: "801-797-7060",
  phoneHref: "tel:+18017977060",
  email: "injectionspluswithnichole@gmail.com",
  instagram: "@releafbynichole",
  instagramUrl: "https://www.instagram.com/releafbynichole",
  addressLines: ["Salon 406", "406 E 2650 N", "North Ogden, UT 84414"],
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=406+E+2650+N+North+Ogden+UT+84414",
};

export const VISIT_TYPE_LABELS = {
  in_person: "In-Person",
  phone: "Phone",
  telehealth: "Telehealth",
};

export function formatPrice(p) {
  return p > 0 ? `$${p}` : "Complimentary";
}

export function formatTime12(t) {
  const [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "PM" : "AM";
  return `${h % 12 || 12}:${String(m).padStart(2, "0")} ${ap}`;
}

export const SERVICE_GROUPS = [
  {
    category: "Consultations",
    note: "Consultations are complimentary — 30 minutes, one-on-one with Nichole.",
    services: [
      { id: "consult", name: "In-Person Consultation", price: 0, duration: 30, visitType: "in_person", blurb: "A private, unhurried visit at Salon 406 to map out your goals and options." },
      { id: "phone", name: "Phone Consultation", price: 60, duration: 20, visitType: "phone", blurb: "Speak directly with Nichole by phone — questions, pricing, and next steps." },
    ],
  },
  {
    category: "Injectables",
    note: "Complimentary 30-minute consultation.",
    services: [
      { id: "botox", name: "Botox", price: 0, duration: 30, visitType: "in_person", blurb: "Wrinkle relaxer consultation for softening lines with natural movement." },
      { id: "dysport", name: "Dysport", price: 0, duration: 30, visitType: "in_person", blurb: "Neurotoxin consultation — a softer, faster-settling alternative for expression lines." },
      { id: "fillers", name: "Dermal Fillers", price: 0, duration: 30, visitType: "in_person", blurb: "Consultation for restoring volume and contour with a conservative hand." },
    ],
  },
  {
    category: "Weight Loss",
    note: "Initial consultation $199 — includes GLP-1 education, baseline measurements, and your individualized plan.",
    services: [
      { id: "weight-loss-consult", name: "Weight Loss Initial Consultation", price: 199, duration: 45, visitType: "in_person", blurb: "Complete medical & weight history, medication review, baseline measurements, GLP-1 education and injection training, and labs when indicated." },
    ],
  },
  {
    category: "Hormone Therapy",
    note: "Complimentary 30-minute consultation.",
    services: [
      { id: "hrt-women", name: "HRT — Women", price: 0, duration: 30, visitType: "in_person", blurb: "Hormone replacement therapy consultation tailored to women." },
      { id: "hrt-men", name: "HRT — Men", price: 0, duration: 30, visitType: "in_person", blurb: "Hormone replacement therapy consultation tailored to men." },
    ],
  },
  {
    category: "Skin & Wellness",
    note: "Complimentary 30-minute consultation.",
    services: [
      { id: "microneedling-prp", name: "Microneedling & PRP", price: 0, duration: 30, visitType: "in_person", blurb: "Collagen-induction and platelet-rich plasma consultation for skin renewal." },
      { id: "facial-tox", name: "Facial Tox", price: 0, duration: 30, visitType: "in_person", blurb: "Full-face neurotoxin consultation for balanced, refreshed results." },
      { id: "migraine-tox", name: "Migraine Tox", price: 0, duration: 30, visitType: "in_person", blurb: "Neurotoxin consultation for chronic migraine relief." },
    ],
  },
  {
    category: "Medical Cannabis",
    note: "Utah Medical Cannabis Cards — new patients in person, renewals by telehealth.",
    services: [
      { id: "cannabis-new", name: "Cannabis Card — New Patient", price: 125, duration: 45, visitType: "in_person", blurb: "In-person evaluation and Utah Medical Cannabis Card certification." },
      { id: "cannabis-renewal", name: "Cannabis Card — Renewal", price: 75, duration: 20, visitType: "telehealth", blurb: "Renew your Utah Medical Cannabis Card from home via telehealth." },
    ],
  },
];

export const ALL_SERVICES = SERVICE_GROUPS.flatMap((g) =>
  g.services.map((s) => ({ ...s, category: g.category }))
);

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1762625570087-6d98fca29531?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxhZXN0aGV0aWMlMjBjbGluaWMlMjBpbnRlcmlvciUyMG5ldXRyYWwlMjB0b25lc3xlbnwwfHx8fDE3ODc3Nzk2ODJ8MA&ixlib=rb-4.1.0&q=85",
  injectables: "https://images.unsplash.com/photo-1544717304-a2db4a7b16ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHx3b21hbiUyMG5hdHVyYWwlMjBiZWF1dHklMjBza2luY2FyZXxlbnwwfHx8fDE3ODc3Nzk2ODJ8MA&ixlib=rb-4.1.0&q=85",
  consultation: "https://images.unsplash.com/photo-1785861001619-b263ebd4e615?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxhZXN0aGV0aWMlMjBjbGluaWMlMjBpbnRlcmlvciUyMG5ldXRyYWwlMjB0b25lc3xlbnwwfHx8fDE3ODc3Nzk2ODJ8MA&ixlib=rb-4.1.0&q=85",
  cannabis: "https://static.prod-images.emergentagent.com/jobs/a278669a-5fe7-47bb-aa18-291ab4fa8180/images/3eb55cad28872040024257ff1521399c4a755655bb79f0909b7732913ff3ecb3.jpeg",
  provider: "https://customer-assets-7cd3h4nn.emergentagent.net/job_nichole-aesthetics/artifacts/spna0mqh_0E0A7617-F231-40E1-9A87-DA70D6553DFE_L0_001-8_17_2026%2C%203_27_03%20AM.webp",
  leaf: "https://images.unsplash.com/photo-1612454001981-ec4f7eed5cc8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxib3RhbmljYWwlMjBsdXh1cnklMjBsZWFmJTIwdGV4dHVyZXxlbnwwfHx8fDE3ODc3Nzk2OTB8MA&ixlib=rb-4.1.0&q=85",
};
